export const legacyColors = {
  B50: '#DEEBFF',
  B75: '#B3D4FF',
  B100: '#4C9AFF',
  B200: '#2684FF',
  B300: '#0065FF',
  B400: '#0052CC',
  G50: '#E3FCEF',
  G75: '#ABF5D1',
  G100: '#79F2C0',
  G200: '#57D9A3',
  G300: '#36B37E',
  G400: '#00875A',
  G500: '#006644',
  N0: '#FFFFFF',
  N20: '#F4F5F7',
  N30: '#EBECF0',
  N40: '#DFE1E6',
  N50: '#C1C7D0',
  N60: '#B3BAC5',
  N80: '#97A0AF',
  N100: '#7A869A',
  N200: '#6B778C',
  N300: '#5E6C84',
  N400: '#505F79',
  N500: '#42526E',
  N800: '#172B4D',
  N20A: 'rgba(9, 30, 66, 0.04)',
  N50A: 'rgba(9, 30, 66, 0.25)',
  N60A: 'rgba(9, 30, 66, 0.31)',
  P50: '#EAE6FF',
  P75: '#C0B6F2',
  P100: '#998DD9',
  P200: '#8777D9',
  P300: '#6554C0',
  P400: '#5243AA',
  P500: '#403294',
  R50: '#FFEBE6',
  R75: '#FFBDAD',
  R100: '#FF8F73',
  R200: '#FF7452',
  R300: '#FF5630',
  R400: '#DE350B',
  R500: '#BF2600',
  T50: '#E6FCFF',
  T75: '#B3F5FF',
  T100: '#79E2F2',
  T200: '#00C7E6',
  Y50: '#FFFAE6',
  Y75: '#FFF0B3',
  Y100: '#FFE380',
  Y200: '#FFC400',
  Y300: '#FFAB00'
} as const;
